import React from "react"
import PropTypes from "prop-types"

export default class BasicErrorPage extends React.Component {
  render() {
    const { errorCode, errorTitle, description, children } = this.props
    return (
      <div className="basic-error-page">
        <h2>{errorCode}</h2>
        <h1>{errorTitle}</h1>
        <div className="basic-error-page-description">{description}</div>
        {children}
      </div>
    )
  }
}

BasicErrorPage.propTypes = {
  errorCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  errorTitle: PropTypes.string.isRequired,
  description: PropTypes.string,
}
